import * as actions from "./actionsTypes";

const initialData = {
  loaderIndikator: false,
  loaderIndikators: false,
  saveLoaderIndikator: false,
  indikators: null,
  indikator: null,
  indikatorsFaild: null,
  indikatorFaild: null,
  formIndikatorFaild: null  
};

export default function IndikatorsReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_INDIKATOR:
      return { ...state, loaderIndikator: action.payload };
    case actions.LOADER_INDIKATORS:
      return { ...state, loaderIndikators: action.payload };
    case actions.SAVE_LOADER_INDIKATOR:
      return { ...state, saveLoaderIndikator: action.payload };
    case actions.GET_INDIKATOR:
      return { ...state, indikator: action.payload };
    case actions.GET_INDIKATORS:
      return { ...state, indikators: action.payload };
    case actions.INDIKATOR_FAIL:
      return { ...state, indikatorFaild: action.payload };
    case actions.INDIKATORS_FAIL:
      return { ...state, indikatorsFaild: action.payload };
    case actions.FORM_INDIKATORS_FAIL:
      return { ...state, formIndikatorFaild: action.payload };
    default:
      return state;
  }
}
